import { Theme } from '@material-ui/core';
import { lightGray } from '../theme';
import { ThemeOptions } from '@material-ui/core/styles';

export const inputTheme = (theme: Theme): ThemeOptions => ({
    overrides: {
        MuiFormHelperText: {
            root: {
                textAlign: 'left',
                paddingLeft: 16,
            },
        },
        MuiInputAdornment: {
            root: {
                position: 'absolute',
            },
            positionEnd: {
                right: '16px',
            },
            positionStart: {
                left: '16px',
                zIndex: 1,
            },
        },
        MuiInput: {
            formControl: {
                'label + &': {
                    marginTop: theme.spacing(4),
                },
            },
        },
        MuiFormLabel: {
            root: {
                background: '#fff',
                paddingLeft: 5,
                paddingRight: 5,
                top: '16px !important',
                left: '16px !important',
                zIndex: 99,
            },
        },
        MuiInputBase: {
            input: {
                position: 'relative',
                transition: theme.transitions.create(['border-color']),
                borderRadius: 4,
                backgroundColor: theme.palette.background.paper,
                fontSize: 16,
                width: '100%',
                border: `1px solid ${lightGray}`,
                padding: 16,
            },
            inputAdornedStart: {
                paddingLeft: 45,
            },
            inputMarginDense: {
                paddingTop: 5,
                paddingBottom: 5,
            },
        },
    },
    props: {
        MuiInputLabel: {
            shrink: true,
        },
        MuiInput: {
            disableUnderline: true,
        },
    },
});
